/*
 * This software system consists of computer software and documentation.
 * It contains trade secrets and confidential information which are proprietary
 * to Everi Games Inc.  Its use or disclosure in whole or in part without
 * the express written permission of Everi Games Inc. is prohibited.
 *
 * This software system is also an unpublished work protected under the copyright
 * laws of the United States of America.
 *
 * Copyright (c) 2018 Everi Games Inc.  All Rights Reserved
 */
import ComponentBase from "../../ComponentBase";

const {ccclass} = cc._decorator;

/**
 * PersistRootNode
 */
@ccclass
export class PersistRootNode extends ComponentBase {
	start(): void {
		cc.game.addPersistRootNode(this.node);
	}
}